import {
    BulletList,
    Exercise,
    LabelBody,
    LabelBodyHeadline,
    LabelDisplay2,
    SecondaryButton,
    Spacer,
} from '../../components';
import { ExerciseViewProps } from '../../exercises';
import {
    IllustrationListenPhone,
    IllustrationScribbling,
    IllustrationStargaze,
    IllustrationThinking,
} from '../../icons';
import { ExerciseStatus } from '../../interfaces';

export function ModuleIntroExercise({
    exercise,
    onContinue,
}: ExerciseViewProps) {
    function Page() {
        switch (exercise.CurrentPage) {
            default:
            case 1:
                return (
                    <Page1
                        onContinue={() => {
                            onContinue({
                                pageNumber: 2,
                                status: ExerciseStatus.InProgress,
                            });
                        }}
                    />
                );
            case 2:
                return (
                    <Page2
                        onContinue={() => {
                            onContinue({
                                pageNumber: 3,
                                status: ExerciseStatus.InProgress,
                            });
                        }}
                    />
                );
            case 3:
                return (
                    <Page3
                        onContinue={() => {
                            onContinue({
                                pageNumber: 4,
                                status: ExerciseStatus.InProgress,
                            });
                        }}
                    />
                );
            case 4:
                return (
                    <Page4
                        onContinue={() => {
                            onContinue({
                                goToNext: false,
                                status: ExerciseStatus.Completed,
                            });
                        }}
                    />
                );
        }
    }

    return (
        <Exercise title="Forberedelse til samtale">
            <Page />
        </Exercise>
    );
}

type PageProps = {
    onContinue: () => void;
};
function Page1({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">
                Forbered dig til din samtale
            </LabelDisplay2>
            <LabelBody>
                Du skal snart i gang med dit forløb, der starter med en samtale
                med din psykolog.
            </LabelBody>
            <LabelBodyHeadline class="my-10 text-dark-red">
                Du vil blive præsenteret for nogle emner, der er gode at tænke
                over
            </LabelBodyHeadline>
            <LabelBody>
                Noter på et papir, hvad du tænker. Hvis du vil dele det med din
                psykolog, kan du have papiret med dig til din første samtale. 
            </LabelBody>
            <IllustrationScribbling className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Se første emne
            </SecondaryButton>
        </>
    );
}

function Page2({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2>Dine behov</LabelDisplay2>
            <LabelBody class="my-10">
                Overvej hvad du har brug for, når noget er svært. Fra dig selv
                og fra andre.
            </LabelBody>
            <LabelBody>
                <span className="font-bold text-dark-red">
                    Du kan for eksempel overveje:
                </span>
                <BulletList
                    className="mt-10"
                    items={[
                        'Har du brug for at tale med en ven om din situation?',
                        'Har du brug for at lave flere af de ting, der plejer at gøre dig afslappet?',
                        'Andet?',
                    ]}
                />
            </LabelBody>
            <LabelBody class="mt-10">
                <span className="font-bold text-dark-red">
                    Overvej også gerne, hvad du har brug for fra psykologen
                </span>
                <BulletList
                    className="mt-10"
                    items={[
                        'Er du mest til at psykologen lytter, giver råd eller spørger til noget bestemt?',
                    ]}
                />
            </LabelBody>
            <LabelBody class="mt-10">
                Du kan hjælpe psykologen ved at fortælle, hvis der er noget, du
                ikke bryder dig om, eller noget du ved virker for dig. Det er
                også helt ok, hvis du ikke ved det.
            </LabelBody>
            <IllustrationThinking className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Se næste emne
            </SecondaryButton>
        </>
    );
}

function Page3({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Din trivsel</LabelDisplay2>
            <LabelBody>
                Hvis du havde al den plads og tid i verden, du kunne ønske dig.
                Og dine bekymringer og tanker ikke stod i vejen. Hvad ville
                man så kunne se dig gøre?
                <BulletList
                    class="my-10"
                    items={[
                        'Hvad ville du gøre mere og mindre af?',
                        'Hvad ville du starte med at gøre?',
                        'Hvad ville du stoppe med at gøre?',
                    ]}
                />
                Overvej også hvad du holder af i livet og hvad du godt kan lide
                at lave.
            </LabelBody>
            <IllustrationStargaze className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>
                Se næste emne
            </SecondaryButton>
        </>
    );
}

function Page4({ onContinue }: PageProps) {
    return (
        <>
            <LabelDisplay2 class="mb-10">Dine refleksioner</LabelDisplay2>
            <LabelBody>
                Du er nu klar til at have din samtale med psykologen.
            </LabelBody>
            <LabelBody class="mt-10">
                Det kan være en god idé at dele, hvad du har tænkt over og
                skrevet ned. På den måde kan psykologen blive klogere på dig og
                hvordan du bedst hjælpes.
            </LabelBody>
            <IllustrationListenPhone className="mx-auto my-30" />
            <Spacer />
            <SecondaryButton onClick={onContinue}>Afslut</SecondaryButton>
        </>
    );
}
